import { call, put, select } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'
import {
  add as addUserGroup
} from 'store/redux/userGroups'
import {
  add as addUserGroupToView
} from '../redux/userGroups'
import sweetalert from 'sweetalert2'

export default function * requestAddUserGroup (action) {
  const { name, description, external, onAdd } = action.payload

  try {
    const Group = yield call(apiAction, 'AddGroup', {
      name,
      description,
      external
    })

    yield put(addUserGroup({
      id: Group.Id,
      name: Group.Name,
      description: Group.Description,
      internal: Group.Internal,
      external: Group.External,
    }))

    yield put(addUserGroupToView({
      id: Group.Id,
      usersCount: Group.UsersCount
    }))

    onAdd(Group.Id)
  } catch (error) {
    if (error.code === 300) {
      const state = yield select()

      try {
        yield call(sweetalert, {
          type: 'error',
          text: state.kanbo.locale.messages['USER_GROUP_NAME_IN_USE']
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
